import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ChatPanelState {
  isChatOpen: boolean
  isFullscreen: boolean
  /** Which screen edge the panel slides in from. */
  side: 'left' | 'right'
  openChat: () => void
  closeChat: () => void
  toggleChat: () => void
  toggleFullscreen: () => void
  setSide: (side: 'left' | 'right') => void
  toggleSide: () => void
}

export const useChatPanel = create<ChatPanelState>()(
  persist(
    (set) => ({
      isChatOpen: false,
      isFullscreen: false,
      side: 'right',
      openChat: () => set({ isChatOpen: true }),
      closeChat: () => set({ isChatOpen: false }),
      toggleChat: () => set((state) => ({ isChatOpen: !state.isChatOpen })),
      toggleFullscreen: () => set((state) => ({
        isFullscreen: !state.isFullscreen,
        isChatOpen: true,
      })),
      setSide: (side) => set({ side }),
      toggleSide: () => set((state) => ({ side: state.side === 'right' ? 'left' : 'right' })),
    }),
    {
      name: 'chat-panel-state',
      // Every page load starts with chat closed: never save the open flag, and
      // ignore one left in storage by older builds.
      partialize: ({ isFullscreen, side }) => ({ isFullscreen, side }),
      merge: (persisted, current) => ({ ...current, ...(persisted as Partial<ChatPanelState>), isChatOpen: false }),
    }
  )
)

// Keep the old export for backward compatibility
export const useMobileMenu = useChatPanel
